import { ActionStatus, buildActionType, StateStatus } from '../core';

const initialState = {
  data: null,
  errors: null,
  status: StateStatus.NOT_INITIALIZED,
  version: 0,
  report: null,
};

const videos =
  actionType =>
  (state = initialState, action) => {
    switch (action.type) {
      case buildActionType(actionType, ActionStatus.START):
        return { ...initialState, status: StateStatus.LOADING, version: state.version, entity: actionType.entity };

      case buildActionType(actionType, ActionStatus.DONE):
        return { status: StateStatus.LOADED, data: action.payload, entity: actionType.entity, version: +new Date(), report: action.report };

      case buildActionType(actionType, ActionStatus.FAILED):
        return { status: StateStatus.ERROR, errors: action.payload, entity: actionType.entity };

      case buildActionType(actionType, ActionStatus.RESET):
        return initialState;

      case buildActionType(actionType, ActionStatus.UPDATE):
        return {
          ...state,
          data: [...action.newArr],
        };
      case buildActionType(actionType, ActionStatus.INCREASE):
        return {
          ...state,
          data: [
            ...state.data.slice(0, action.index),
            { ...state.data[action.index], related: parseInt(state.data[action.index].related) + 1 },
            ...state.data.slice(action.index + 1),
          ],
        };
      case buildActionType(actionType, ActionStatus.DECREASE):
        return {
          ...state,
          data: [
            ...state.data.slice(0, action.index),
            { ...state.data[action.index], related: parseInt(state.data[action.index].related) - 1 },
            ...state.data.slice(action.index + 1),
          ],
        };

      default:
        return state;
    }
  };

export { videos };
